import script from "./SellerLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./SellerLayout.vue?vue&type=script&setup=true&lang=js"

import "./SellerLayout.vue?vue&type=style&index=0&id=71493df4&lang=css"

const __exports__ = script;

export default __exports__